

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class UserDashboardItem_ManagedObject

class UserDashboardItem_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: config
    set config(value:string) {
        this.setValueForKey(value, 'config');
    }
    get config():string {
        return this.valueForKey('config');
    }
    set configPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'config');
    }
    get configPrimitiveValue():string {
        return this.primitiveValueForKey('config');
    }

    // Property: hidden
    set hidden(value:boolean) {
        this.setValueForKey(value, 'hidden');
    }
    get hidden():boolean {
        return this.valueForKey('hidden');
    }
    set hiddenPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'hidden');
    }
    get hiddenPrimitiveValue():boolean {
        return this.primitiveValueForKey('hidden');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: rowBreak
    set rowBreak(value:boolean) {
        this.setValueForKey(value, 'rowBreak');
    }
    get rowBreak():boolean {
        return this.valueForKey('rowBreak');
    }
    set rowBreakPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'rowBreak');
    }
    get rowBreakPrimitiveValue():boolean {
        return this.primitiveValueForKey('rowBreak');
    }

    // Property: widgetID
    set widgetID(value:string) {
        this.setValueForKey(value, 'widgetID');
    }
    get widgetID():string {
        return this.valueForKey('widgetID');
    }
    set widgetIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'widgetID');
    }
    get widgetIDPrimitiveValue():string {
        return this.primitiveValueForKey('widgetID');
    }
    // Relationship: user
    set user(value:User) {
        this.setValueForKey(value, 'user');
    }
    get user():User {
        return this.valueForKey('user') as User;
    }
}
